import CRUDReducer from './CRUDReducer';
import countriesCRUDActions from '../actions/countries';

const countriesCRUDReducer = new CRUDReducer(countriesCRUDActions);

export default (state, action) => countriesCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/countries.js